import React from 'react';
import { Tab, Nav } from 'react-bootstrap';
import LinkedinLoginForm from '../OAuth/Linkedin/LinkedinLoginForm';
import FacebookLoginForm from '../OAuth/Facebook/FacebookLoginForm';
import XLoginForm from '../OAuth/X/XLoginForm';
import Styles from './Integrations.module.scss';

const IntegrationNavItem = ({ type, onClick }) => (
  <div key={type}>
    <Nav.Item>
      <Nav.Link
        className={`${Styles.IntegrationBtn} rounded-4`}
        onClick={() => onClick(type)}
      >
        <img
          src={`/Images/logo-${type.toLowerCase()}.png`}
          alt={type}
          width="50"
          height="50"
        />
        <p>{type}</p>
      </Nav.Link>
    </Nav.Item>
  </div>
);

const IntegrationPlatformList = ({
  availableIntegrations = [],
  onPlatformSelect,
  onSocialSuccess,
}) => {
  return (
    <Tab.Container id="integration-tabs">
      <Nav variant="pills" className={Styles.integrationCardGrid}>
        {availableIntegrations.map((integration) => (
          <IntegrationNavItem
            key={integration.type}
            type={integration.type}
            onClick={onPlatformSelect}
          />
        ))}
        <div key={'linkedin'}>
          <Nav.Item>
            <Nav.Link className="p-0">
              <LinkedinLoginForm onLoginSuccess={onSocialSuccess} />
            </Nav.Link>
          </Nav.Item>
        </div>
        <div key={'facebook'}>
          <Nav.Item>
            <Nav.Link className="p-0">
              <FacebookLoginForm onLoginSuccess={onSocialSuccess} />
            </Nav.Link>
          </Nav.Item>
        </div>
        <div key={'Xlogin'}>
          <Nav.Item>
            <Nav.Link className="p-0">
              <XLoginForm onLoginSuccess={onSocialSuccess} />
            </Nav.Link>
          </Nav.Item>
        </div>
      </Nav>
    </Tab.Container>
  );
};

export default IntegrationPlatformList;
export { IntegrationNavItem };
